/**
 * canEdit.js — single source of truth for "can this viewer edit this item?"
 *
 * A viewer can edit a library item when:
 *   • they are an admin (god-mode across all content), OR
 *   • they are a scribe AND their SpaceToggle is on "writer" AND they own
 *     the item (item.user_id matches their user_id).
 *
 * Readers never see edit controls. Writers toggled into Reader Space
 * never see edit controls. Writers in Writer Space only see controls on
 * their own uploads, not on admin/other-writer content.
 */

export function canEditItem({ userRole, userId, activeSpace, item }) {
  if (userRole === 'admin') return true;
  if (userRole !== 'writer') return false;
  if (activeSpace !== 'writer') return false;
  const owner = item && (item.user_id || item.owner_id);
  return !!owner && owner === userId;
}

/**
 * Role-level check: does this viewer have *any* edit capability at all
 * (used to decide whether to render management UI chrome like the
 * top-of-grid "Manage Series" header, the Upload CTAs, etc.)?
 */
export function hasAnyEditPower({ userRole, activeSpace }) {
  if (userRole === 'admin') return true;
  if (userRole === 'writer' && activeSpace === 'writer') return true;
  return false;
}
